export default "__VITE_ASSET__BnWeHAwV__"